module.exports = __webpack_public_path__ + "static/media/striped_bar_liquidStrip.1100cc96.svg";